import React, { useEffect } from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import { ChatContainer } from "../../../widget/common/ui/MainContainer";
import { ChatsContextProvider } from "../../../provider/chats/chats/chats/ChatsContextProvider";
import ConversationActions from "../widget/chat_conversation/ConversationActions";
import { ConversationHeaders } from "../widget/chat_conversation/ConversationHeaders";
import { TeamChatsContextProvider } from "../../../provider/chats/chats/team_chats/TeamChatsContextProvider";
import ConversationContent from "../widget/chat_conversation/ConversationContent";
import { DepartmentChatsContextProvider } from "../../../provider/chats/chats/department_chats/DepartmentChatsContextProvider";
import { GroupChatsContextProvider } from "../../../provider/chats/chats/group_chats/GroupChatsContextProvider";
import { loadGoogleMapsScript } from "../../../libraries/google_map/LoadGoogleMapsScript";

const TeamChatScreen = () => {
  //const type: number = ResponsiveDeviceType();

  /* useEffect(() => {
    const chatDetail: TeamResults | null =
      ChatsProvider.getChatConversationDetailSession();

    if (chatDetail != null) {
      if (chatDetail?.flag !== "1") {
        navigate(appRoutes.routeNameChats, { replace: true });
      }
    }
  }, []); */

  useEffect(() => {
    loadGoogleMapsScript()
      .then(() => {
        console.log("Google Maps loaded");
      })
      .catch(console.error);
  }, []);

  return (
    <ChatsContextProvider>
      <TeamChatsContextProvider>
        <DepartmentChatsContextProvider>
          <GroupChatsContextProvider>
            <Scaffold
              chatProfile={<ConversationHeaders />}
              appBarAction={<ConversationActions />}
              className="chats-main"
            >
              <ChatContainer>
                <ConversationContent />
              </ChatContainer>
            </Scaffold>
          </GroupChatsContextProvider>
        </DepartmentChatsContextProvider>
      </TeamChatsContextProvider>
    </ChatsContextProvider>
  );
};

export default TeamChatScreen;
export const routeName: string = "/team-chat";
